import { inject, onUnmounted } from "vue";

export function useAnimations() {
  const gsap = inject("gsap");
  const ScrollTrigger = inject("ScrollTrigger");

  let scrollTriggers = [];

  // Fade in and slide up animation
  const fadeInUp = (elements, options = {}) => {
    const defaults = {
      y: 50,
      opacity: 0,
      duration: 0.8,
      ease: "power2.out",
      stagger: 0.16,
      delay: 0,
      scrollTrigger: {
        trigger: elements,
        start: "top 80%",
        toggleActions: "play none none none",
      },
    };

    const mergedOptions = { ...defaults, ...options };

    const animation = gsap.from(elements, mergedOptions);

    if (mergedOptions.scrollTrigger) {
      scrollTriggers.push(
        ScrollTrigger.create({
          ...mergedOptions.scrollTrigger,
          animation: animation,
        })
      );
    }

    return animation;
  };

  // Text reveal animation
  const textReveal = (elements, options = {}) => {
    const defaults = {
      y: 100,
      opacity: 0,
      duration: 0.96,
      ease: "power3.out",
      stagger: 0.08,
      scrollTrigger: {
        trigger: elements,
        start: "top 85%",
        toggleActions: "play none none none",
      },
    };

    const mergedOptions = { ...defaults, ...options };

    const animation = gsap.from(elements, mergedOptions);

    if (mergedOptions.scrollTrigger) {
      scrollTriggers.push(
        ScrollTrigger.create({
          ...mergedOptions.scrollTrigger,
          animation: animation,
        })
      );
    }

    return animation;
  };

  // Clean up ScrollTriggers on component unmount
  onUnmounted(() => {
    scrollTriggers.forEach((trigger) => trigger.kill());
    scrollTriggers = [];
  });

  return {
    fadeInUp,
    textReveal,
    gsap,
    ScrollTrigger,
  };
}
